import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.jsx';
import { useStore } from '../context/StoreContext.jsx';

export function Footer() {
  const { language, t } = useLanguage();
  const { storeConfig } = useStore();

  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>AutoAlibaba</h4>
            <p style={{ fontSize: '0.875rem', marginBottom: '1rem', color: '#94a3b8' }}>
              {language === 'ar' ? storeConfig.description.ar : storeConfig.description.fr}
            </p>
            <p className="ltr-only" style={{ fontSize: '0.875rem', color: '#cbd5e1' }}>
              📞 {storeConfig.contact.phone}
            </p>
          </div>

          <div className="footer-col">
            <h4>{t('catalog')}</h4>
            <ul>
              <li><Link to="/catalogue">{t('allCategories')}</Link></li>
              <li><Link to="/catalogue?on_sale=true">{t('onSaleOnly')}</Link></li>
              <li><Link to="/catalogue?in_stock=true">{t('inStockOnly')}</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{t('orderTracking')}</h4>
            <ul>
              <li><Link to="/suivi">{t('orderTracking')}</Link></li>
              <li><Link to="/contact">{t('contact')}</Link></li>
              <li><span>{t('payOnDelivery')}</span></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{t('contact')}</h4>
            <ul>
              <li><span>{storeConfig.contact.address}</span></li>
              <li><span>{language === 'ar' ? storeConfig.contact.workingHours.ar : storeConfig.contact.workingHours.fr}</span></li>
              <li><span className="ltr-only">{storeConfig.contact.email}</span></li>
              <li><Link to="/politique-confidentialite">{language === 'ar' ? 'سياسة الخصوصية' : 'Politique de confidentialité'}</Link></li>
              <li><Link to="/conditions-utilisation">{language === 'ar' ? 'شروط الاستخدام' : 'Conditions d’utilisation'}</Link></li>
              <li><Link to="/suppression-donnees">{language === 'ar' ? 'حذف البيانات' : 'Suppression des données'}</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {currentYear} AutoAlibaba. {t('announcement')}</span>
          <span>{language === 'ar' ? 'متجر مغربي لمنتجات السيارات' : 'Boutique automobile marocaine'}</span>
        </div>
      </div>
    </footer>
  );
}
